<template>
    <div id="app">
        <div class="header-fixed">
            <transition name="transitionFade">
                <cookie-banner v-if="!disableCookieBanner && !hasAcceptedCookies && !isCanvasser" />
            </transition>

            <transition name="transitionFade">
                <router-view name="topNavigation"></router-view>
            </transition>
        </div>

        <div class="router__container" :key="$route.fullPath">
            <transition :name="transitionName">
                <router-view :key="$route.fullPath"></router-view>
            </transition>
        </div>

        <transition name="transitionFade">
            <router-view name="orderSummaryModal"></router-view>
        </transition>

        <transition name="transitionFade">
                <router-view name="footer" :pageName="$route.name"></router-view>
        </transition>

        <country-switch-modal v-show="showCountryModal" :appLocation="appLocation" :userLocation="userLocation"/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CountrySwitchModal from '@/components/modals/CountrySwitchModal';
import Countries from '@/resources/countrySwitcher.json';
import CookieBanner from '@/components/structure/CookieBanner';

const i18n = require('@/i18n').default;

export default {
    name: 'FrontEndWebsite',
    data() {
        return {
            transitionName: '',
            userInDifferentLocation: false,
            appLocation: null,
            userLocation: null,
        };
    },
    components: {
        CookieBanner,
        CountrySwitchModal,
    },
    mounted() {
        this.$store.commit('cookies/setAwcValue', this.$route.query.awc);
        this.$store.dispatch('cookies/mountScripts');
        setTimeout(() => {
            const location = JSON.parse(sessionStorage.getItem('ABTastyGeoloc'));
            const appIso = process.env.VUE_APP_COUNTRY_ISO;
            this.appLocation = Countries.find(country => country.geocode === appIso || country.iso === appIso);
            this.userLocation = Countries.find(country => (location && location.country_iso_code === country.geocode) || (location && location.country_iso_code === country.iso));

            // if the users location is available in the country list, then we can show the modal if its a different location from the app location
            this.userInDifferentLocation = this.appLocation && this.userLocation && this.userLocation.iso !== this.appLocation.iso;
        }, 2000);
    },
    watch: {
        '$route'(to, from) {
            if (to.meta && to.meta.order && from.meta && from.meta.order) {
                this.transitionName = to.meta.order > from.meta.order ? 'transitionSlideNext' : 'transitionSlidePrevious';
            } else {
                this.transitionName = 'transitionFade';
            }
        },
    },

    metaInfo: {
        title: i18n.t('META_TITLE'),
        titleTemplate: null,
        meta: [
            { name: 'description', content: i18n.t('META_DESCRIPTION') },
            { name: 'keywords', content: i18n.t('META_KEYWORDS') },
        ],
    },
    computed: {
        ...mapGetters({
            hasAnsweredCountrySwitch: 'account/getHasAnsweredCountrySwitch',
            hasAcceptedCookies: 'cookies/getHasAnsweredCookieForm',
            isCanvasser: 'auth/isCanvasser',
        }),
        showCountryModal() {
            return this.userInDifferentLocation && !this.hasAnsweredCountrySwitch;
        },
        language() {
            return this.$root.$i18n.locale;
        },
        disableCookieBanner() {
            return process.env.VUE_APP_DISABLE_COOKIE_BANNER === 'true';
        },
    },
};
</script>
<style lang="scss">
    @import "@/assets/sass/app.scss";

    .header-fixed {
            position: fixed;
            z-index: 1000;
            width: 100%;
    }
    ::-webkit-scrollbar {
        display: none; /* Chrome & Safari */
    }
</style>
